import type { FaireProductEntity } from "../../entity_types/product";

export const p_2xed6tt75w: FaireProductEntity = {
  token: "p_2xed6tt75w",
  type: "product",
  name: "UPD ST8949DI Hello Kitty and Friends Stickers - 24 ",
  brandName: "PINEAPPLE Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/57646b21da49bf76bbe1531bf46203fe5dca37fe7c4874078eb3f52beeb14b34.jpeg",
  priceDollars: 1.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0d87a82ff9de40e61c74adc55d8de6330bbe15fdda5bce199532d4ff085d982d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
